// client/src/components/dashboard/account/AccountPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import ProfileForm from './ProfileForm'; // Import the self-contained ProfileForm
import ContactForm from './ContactForm';
import EmergencyContactsManager from './EmergencyContactsManager';
// import { useAuth } from '../../../context/AuthContext.js';
// Removed imports: useState, useEffect, useAuth, LoadingSpinner, axios

import './AccountPage.css';

function AccountPage() {
    const { t } = useTranslation();
    // const { user } = useAuth();
    // if (!user) {
    //     return <p>{t('account.notLoggedIn')}</p>; // Optional: Check auth at this level if needed
    // }

    return (
        <div className="account-container">
            <div className="account-title-container">
                <h1>{t('dashboard.account.title')}</h1>
            </div>
            <div className="profile-details">
                <h2>{t('dashboard.account.profile.title')}</h2>
                 {/* Render ProfileForm without passing state/handlers */}
                <ProfileForm />
            </div>
            <div className="contact-details">
                <h2>{t('dashboard.account.contact.title')}</h2>        
                {/* Render ContactForm without passing state/handlers */}        
                <ContactForm />
            </div>
            <div className="emergency-details">
                <h2>{t('dashboard.account.emergency.title')}</h2>
                {/* Render EmergencyContactForm without passing state/handlers */}     
                <EmergencyContactsManager />
            </div>
            <div >
                &copy; {new Date().getFullYear()} beinSmart.cloud. {t('footer.allRightsReserved')}
            </div>
        </div>
    );
}

export default AccountPage;